__turbopack_context__.v({
  "testimonialContainer": "testimonials-module-scss-module__2ZJ91a__testimonialContainer",
  "testimonialSection": "testimonials-module-scss-module__2ZJ91a__testimonialSection",
  "title": "testimonials-module-scss-module__2ZJ91a__title",
});
